export class TableContextSegmentMapCell {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": ""
        },
        {
            "name": "mark",
            "baseName": "mark",
            "type": "TableContextSegmentMark",
            "format": ""
        },
        {
            "name": "applies",
            "baseName": "applies",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSegmentMapCell.attributeTypeMap;
    }
    constructor() {
    }
}
